import { type QueryClient, queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { ItemsApi } from '@/lib/api/common/items';
import type { ItemFiltersType } from '@/lib/api/types/itemFilters';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const invalidateItems = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: commonQueryKeys.items.all() });
};

const itemsQueryOptions = ({
  enabled,
  filter,
  limit,
  order,
}: {
  enabled?: boolean;
  filter?: ItemFiltersType;
  limit?: number;
  order?: string;
}) =>
  queryOptions({
    queryKey: commonQueryKeys.items.byFilters({ filter, limit, order }),
    queryFn: () => ItemsApi.getItems({ filter, limit, order }),
    enabled,
  });

export const useSuspenseItemsQuery = ({
  filter,
  limit,
}: {
  filter?: ItemFiltersType;
  limit?: number;
}) => {
  return useSuspenseQuery(itemsQueryOptions({ filter, limit }));
};

export const useItemsQuery = ({
  enabled,
  filter,
  limit,
  order,
}: {
  enabled?: boolean;
  filter?: ItemFiltersType;
  limit?: number;
  order?: string;
}) => {
  return useQuery(itemsQueryOptions({ enabled, filter, limit, order }));
};
